import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'

import * as selectors from './selectors'
import { previewModalCurrentIndexSet } from 'Global/Stores/previewModal'
import { userPermissions } from 'Components/Permissions/selectors'

export default function(WrappedComponent) {
  const Enhancer = props => <WrappedComponent {...props} />

  const mapStateToProps = (state, ownProps) => ({
    user: selectors.user(state),
    userPermissions: userPermissions(state),
  })

  const mapDispatchToProps = (dispatch, ownProps) => ({
    setCurrentIndex: index => dispatch(previewModalCurrentIndexSet(index)),
  })

  Enhancer.displayName = 'RugCardEnhancer'

  Enhancer.propTypes = {
    setCurrentIndex: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    userPermissions: PropTypes.array.isRequired,
  }

  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Enhancer)
}
